import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'form-stepper-buttons',
  templateUrl: './stepper-buttons.component.html',
  styleUrls: ['./stepper-buttons.component.scss'],
})
export class StepperButtonsComponent implements OnInit {
  @Input() isFirst = false;
  @Input() isLast = false;
  @Input() customPrevious = false;
  @Output() confirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() previous: EventEmitter<void> = new EventEmitter<void>();
  @Input() stepControl: UntypedFormGroup;

  constructor(private utilsService: UtilsService) {}

  ngOnInit(): void {}

  onConfirm(): void {
    this.confirm.next();
  }

  onPrevious(): void {
    this.previous.next();
  }

  onNextClick(): void {
    if (this.stepControl) {
      this.utilsService.markFormGroupTouched(this.stepControl);
    }
  }
}
